var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.saveNaturalEntity($event)
                }
              }
            },
            [
              _vm.naturalEntity
                ? _c("div", [
                    _c("div", { staticClass: "vx-row" }, [
                      !_vm.isEmployee
                        ? _c(
                            "div",
                            { staticClass: "vx-col w-full mb-2" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Pronome de Tratamento",
                                    "label-for": "pronoun_treatment"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "pronoun_treatment" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "v-select",
                                                {
                                                  attrs: {
                                                    options:
                                                      _vm.pronounTreatmentList,
                                                    label: "name"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.naturalEntity
                                                        .pronounTreatment,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.naturalEntity,
                                                        "pronounTreatment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "naturalEntity.pronounTreatment"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "no-options"
                                                      },
                                                      slot: "no-options"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Nenhum registro encontrado!"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3167629331
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "vx-row" }, [
                      _c(
                        "div",
                        { staticClass: "vx-col w-full mb-2 sm:w-4/12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Nome",
                                "label-for": "first_name"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "Nome", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "required",
                                            attrs: {
                                              id: "first_name",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "first_name"
                                            },
                                            model: {
                                              value:
                                                _vm.naturalEntity.first_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.naturalEntity,
                                                  "first_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "naturalEntity.first_name"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2074419587
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col w-full mb-2 sm:w-8/12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Sobrenome",
                                "label-for": "surname"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "Sobrenome", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "required",
                                            attrs: {
                                              id: "surname",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "surname"
                                            },
                                            model: {
                                              value: _vm.naturalEntity.surname,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.naturalEntity,
                                                  "surname",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "naturalEntity.surname"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2937809970
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", [
                      _vm.isEmployee
                        ? _c(
                            "div",
                            { staticClass: "vx-col w-full mb-2" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Cargo",
                                    "label-for": "position"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "position",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "v-select",
                                                {
                                                  staticClass:
                                                    "required-select",
                                                  attrs: {
                                                    options: _vm.positionList,
                                                    label: "name"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.naturalEntity
                                                        .position,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.naturalEntity,
                                                        "position",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "naturalEntity.position"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "no-options"
                                                      },
                                                      slot: "no-options"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Nenhum registro encontrado!"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      83574847
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "vx-row" }, [
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c("label", [_vm._v("Data Nascimento")]),
                          _c("datepicker", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: ["##/##/####"],
                                expression: "['##/##/####']"
                              }
                            ],
                            attrs: {
                              format: _vm.format,
                              language: _vm.ptBR,
                              typeable: "true"
                            },
                            model: {
                              value: _vm.naturalEntity.birth_date,
                              callback: function($$v) {
                                _vm.$set(_vm.naturalEntity, "birth_date", $$v)
                              },
                              expression: "naturalEntity.birth_date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Estado Civil",
                                "label-for": "marital_status"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "marital_status" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "v-select",
                                            {
                                              attrs: {
                                                options: _vm.maritalStatusList,
                                                label: "name"
                                              },
                                              model: {
                                                value:
                                                  _vm.naturalEntity
                                                    .maritalStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.naturalEntity,
                                                    "maritalStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "naturalEntity.maritalStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "no-options" },
                                                  slot: "no-options"
                                                },
                                                [
                                                  _vm._v(
                                                    "Nenhum registro encontrado!"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  864313715
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Sexo", "label-for": "gender" } },
                            [
                              _c("validation-provider", {
                                attrs: { name: "gender" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "v-select",
                                            {
                                              attrs: {
                                                options: _vm.genderList,
                                                label: "name"
                                              },
                                              model: {
                                                value: _vm.naturalEntity.gender,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.naturalEntity,
                                                    "gender",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "naturalEntity.gender"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "no-options" },
                                                  slot: "no-options"
                                                },
                                                [
                                                  _vm._v(
                                                    "Nenhum registro encontrado!"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3233369619
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "vx-row" }, [
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "CPF",
                                "label-for": "natural_entity_number"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "natural_entity_number" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "mask",
                                                rawName: "v-mask",
                                                value: "###.###.###-##",
                                                expression: "'###.###.###-##'"
                                              }
                                            ],
                                            attrs: {
                                              id: "natural_entity_number",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "natural_entity_number"
                                            },
                                            model: {
                                              value:
                                                _vm.naturalEntity
                                                  .natural_entity_number,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.naturalEntity,
                                                  "natural_entity_number",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "naturalEntity.natural_entity_number"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3983778296
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "RG",
                                "label-for": "identity_number"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "CNPJ" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "identity_number",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "identity_number"
                                            },
                                            model: {
                                              value:
                                                _vm.naturalEntity
                                                  .identity_number,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.naturalEntity,
                                                  "identity_number",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "naturalEntity.identity_number"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1535366690
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                        [
                          _c("label", [_vm._v("Data Expedição")]),
                          _c("datepicker", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: ["##/##/####"],
                                expression: "['##/##/####']"
                              }
                            ],
                            attrs: {
                              format: _vm.format,
                              language: _vm.ptBR,
                              typeable: "true"
                            },
                            model: {
                              value:
                                _vm.naturalEntity.identity_number_issued_at,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.naturalEntity,
                                  "identity_number_issued_at",
                                  $$v
                                )
                              },
                              expression:
                                "naturalEntity.identity_number_issued_at"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "vx-row" }, [
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Estado Nascimento",
                                "label-for": "federation_unit"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "federation_unit" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "v-select",
                                            {
                                              attrs: {
                                                options: _vm.federationUnitList,
                                                label: "name"
                                              },
                                              on: {
                                                input: _vm.selectFederationUnit
                                              },
                                              model: {
                                                value: _vm.federationUnit,
                                                callback: function($$v) {
                                                  _vm.federationUnit = $$v
                                                },
                                                expression: "federationUnit"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "no-options" },
                                                  slot: "no-options"
                                                },
                                                [
                                                  _vm._v(
                                                    "Nenhum registro encontrado!"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2727765661
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Cidade Nascimento",
                                "label-for": "born_city_id"
                              }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "born_city_id" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "v-select",
                                            {
                                              attrs: {
                                                options: _vm.cityList,
                                                label: "name",
                                                disabled: !_vm.showCityList
                                              },
                                              model: {
                                                value:
                                                  _vm.naturalEntity.bornCity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.naturalEntity,
                                                    "bornCity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "naturalEntity.bornCity"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "no-options" },
                                                  slot: "no-options"
                                                },
                                                [
                                                  _vm._v(
                                                    "Nenhum registro encontrado!"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  861252547
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    !_vm.isComplement
                      ? _c("div", { staticClass: "vx-row" }, [
                          _c(
                            "div",
                            { staticClass: "vx-col w-full" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { "400": true }
                                    }
                                  ],
                                  staticClass: "mt-5 float-right",
                                  attrs: { variant: "outline-secondary" },
                                  on: { click: _vm.cancel }
                                },
                                [_vm._v(" Cancelar ")]
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { "400": true }
                                    }
                                  ],
                                  staticClass: "mt-5 mr-2 float-right",
                                  attrs: {
                                    variant: "primary",
                                    disabled: !_vm.validateForm,
                                    type: "submit"
                                  }
                                },
                                [_vm._v(" Salvar ")]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: "Pessoa Natural", active: _vm.showSpouseSearchGrid },
          on: {
            "update:active": function($event) {
              _vm.showSpouseSearchGrid = $event
            }
          }
        },
        [
          _c("Grid", {
            attrs: {
              service: _vm.naturalEntityService,
              route_name: "natural_entities",
              hide_actions: "true",
              delegate: _vm.itemSelected
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }